<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="editedItem.NAME" :label="$t('inputbasic_label1')"></v-text-field>
              </v-row>
              <v-row dense> 
                <v-textarea 
                  counter="250" v-model="editedItem.INPUTDESC" 
                  :label="$t('inputbasic_label2')" value="" outlined :rules="[ v => (v.length <= 250) || this.$t('inputbasic_label3')]"></v-textarea>
              </v-row>
              <v-row dense> 
                <v-textarea 
                  counter="250" v-model="editedItem.INPUTCOMMENT" 
                  :label="$t('inputbasic_label23')" value="" outlined :rules="[ v => (v.length <= 250) || this.$t('inputbasic_label3')]"></v-textarea>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.ENAME" :label="$t('inputbasic_label20')"></v-text-field>
              </v-row>
              <v-row dense> 
                <v-textarea 
                  counter="250" v-model="editedItem.EINPUTDESC" 
                  :label="$t('inputbasic_label21')" value="" outlined :rules="[ v => (v.length <= 250) || this.$t('inputbasic_label3')]"></v-textarea>
              </v-row>
              <v-row dense> 
                <v-textarea 
                  counter="250" v-model="editedItem.EINPUTCOMMENT" 
                  :label="$t('inputbasic_label22')" value="" outlined :rules="[ v => (v.length <= 250) || this.$t('inputbasic_label3')]"></v-textarea>
              </v-row>

              <v-row>
                <v-select v-model="editedItem.LANTYPE" :items="LANLIST" :label="$t('inputbasic_label4')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" @change="changetype"/>
              </v-row>
              <v-row>
                <v-select v-model="editedItem.REQTYPE" :items="REQLIST" :label="$t('inputbasic_label5')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" :disabled="editedItem.LANTYPE == 4"/>
              </v-row>

              <template v-if="editedItem.LANTYPE == 4">
                <v-row dense> 
                  <v-col cols="6">
                    <v-text-field type="number" v-model="editedItem.WIDTH" :label="$t('inputbasic_label6')" counter="4"
                      :rules="[ v => (v.length <= 4) || this.$t('inputbasic_label7'), , v => v || /[0-9]/.test(v) || this.$t('inputbasic_label8')]"
                      />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field type="number" v-model="editedItem.HEIGHT" :label="$t('inputbasic_label19')" counter="4"
                      :rules="[ v => (v.length <= 4) || this.$t('inputbasic_label7'), , v => v || /[0-9]/.test(v) || this.$t('inputbasic_label8')]"
                      />
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="editedItem.LANTYPE < 4">
                <v-row> 
                  <v-text-field 
                    type="number" dense v-model="editedItem.LIMITTEXT" :label="$t('inputbasic_col6')" counter="4"
                    :rules="[ v => (v.length <= 4) || this.$t('inputbasic_label7'), , v => v || /[0-9]/.test(v) || this.$t('inputbasic_label8')]"
                  ></v-text-field>
                </v-row>
                <v-row class="mt-3"> 
                  <v-select v-model="editedItem.MAXLINES" :items="USELIST" :label="$t('inputbasic_col7')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                </v-row>
              </template>

              <v-row class="mt-1">
                <v-select v-model="editedItem.USETYPE" :items="USELIST" :label="$t('inputbasic_col5')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
              </v-row>

              <v-row class="mt-1">
                <v-select v-model="editedItem.SHOWTYPE" :items="USELIST" :label="$t('inputbasic_col12')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="1" sm="12" xs="12">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.NAME>
          <label class="cheader_normal" >{{$t("inputbasic_col1")}}</label>
        </template>
        <template v-slot:header.INPUTDESC>
          <label class="cheader_normal" >{{$t("inputbasic_col2")}}</label>
        </template>
        <template v-slot:header.ENAME>
          <label class="cheader_normal" >{{$t("inputbasic_col10")}}</label>
        </template>
        <template v-slot:header.EINPUTDESC>
          <label class="cheader_normal" >{{$t("inputbasic_col11")}}</label>
        </template>
        <template v-slot:header.LANTYPE>
          <label class="cheader_normal" >{{$t("inputbasic_col3")}}</label>
        </template>
        <template v-slot:header.REQTYPE>
          <label class="cheader_normal" >{{$t("inputbasic_col4")}}</label>
        </template>
        <template v-slot:header.USETYPE>
          <label class="cheader_normal" >{{$t("inputbasic_col5")}}</label>
        </template>
        <template v-slot:header.SHOWTYPE>
          <label class="cheader_normal" >{{$t("inputbasic_col12")}}</label>
        </template>
        <template v-slot:header.LIMITTEXT>
          <label class="cheader_normal" >{{$t("inputbasic_col6")}}</label>
        </template>
        <template v-slot:header.MAXLINES>
          <label class="cheader_normal" >{{$t("inputbasic_col7")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("inputbasic_col8")}}</label>
        </template>
                                                                

        <template v-slot:item.LANTYPE="{ item }">  
          <template v-if="item.LANTYPE == 1">
            <label style="text-align:center">{{$t('inputbasic_label11')}}</label>
          </template>
          <template v-else-if="item.LANTYPE == 2">
            <label style="text-align:center">{{$t('inputbasic_label12')}}</label>
          </template>
          <template v-else-if="item.LANTYPE == 3">
            <label style="text-align:center">{{$t('inputbasic_label13')}}</label>
          </template>
          <template v-else>
            <label style="text-align:center">{{$t('inputbasic_label14')}}</label>
          </template>
        </template>     
        <template v-slot:item.REQTYPE="{ item }">  
          <template v-if="item.REQTYPE == 0">
            <label style="text-align:center">{{$t('inputbasic_label15')}}</label>
          </template>
          <template v-else-if="item.REQTYPE == 1">
            <label style="text-align:center">{{$t('inputbasic_label16')}}</label>
          </template>
        </template>     
        <template v-slot:item.USETYPE="{ item }">  
          <template v-if="item.USETYPE == 0">
            <label style="text-align:center">{{$t('inputbasic_label17')}}</label>
          </template>
          <template v-else-if="item.USETYPE == 1">
            <label style="text-align:center">{{$t('inputbasic_label18')}}</label>
          </template>
        </template>     
        <template v-slot:item.SHOWTYPE="{ item }">  
          <template v-if="item.SHOWTYPE == 0">
            <label style="text-align:center">{{$t('inputbasic_label17')}}</label>
          </template>
          <template v-else-if="item.SHOWTYPE == 1">
            <label style="text-align:center">{{$t('inputbasic_label18')}}</label>
          </template>
        </template>     
        <template v-slot:[`item.MAXLINES`]="{ item }">  
          <template v-if="item.MAXLINES == 0">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputbasic_label17')}}</label>
          </template>
          <template v-else-if="item.MAXLINES == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputbasic_label18')}}</label>
          </template>
        </template>     

        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
//import dateFormat from 'dateformat'
export default {
    data: () => ({

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          NAME:'',
          INPUTDESC:'',
          ENAME:'',
          EINPUTDESC:'',
          INPUTCOMMENT:'',
          EINPUTCOMMENT:'',
          LIMITTEXT:20,
          LANTYPE:1,
          REQTYPE:1,
          USETYPE:1,
          SHOWTYPE:1,
          WIDTH:100,
          HEIGHT:100,
      },
      editedItem: {
      },
      unusetext:'color:#b0b0b0;text-align:center',
      usetext:'color:black;text-align:center',


      //테이블 정의
      headers: [
        {text: '항목',    value: 'NAME', sortable: true, align:'left' },
        {text: '항목설명',  value: 'INPUTDESC', sortable: true, align:'left'},
        {text: '항목(영문)',    value: 'ENAME', sortable: true, align:'left' },
        {text: '항목설명(영문)',  value: 'EINPUTDESC', sortable: true, align:'left'},
        {text: '언어',    value: 'LANTYPE', sortable: true, align:'center'},
        {text: '필수여부',    value: 'REQTYPE', sortable: true, align:'center'},
        {text: '사용',    value: 'USETYPE', sortable: true, align:'center'},
        {text: '명단노출',    value: 'SHOWTYPE', sortable: true, align:'center'},
        {text: '입력제한',    value: 'LIMITTEXT', sortable: true, align:'center'},
        {text: '멀티라인',    value: 'MAXLINES', sortable: true, align:'center'},
        {text: '수정',    value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],
      
      //추가 변수들
      LANLIST: [
          {name:'한글', name2:"Korean",  value:1}
        , {name:'영문',  name2:"English", value:2}
        , {name:'한글영어', name2:"Korean&English",  value:3}
        , {name:'이미지', name2:"Image", value:4}
        , {name:'파일', name2:"File", value:5}
      ],
      REQLIST: [
          {name:'선택입력',  name2:"Choice", value:0}
        , {name:'필수입력',  name2:"Required", value:1}
      ],
      USELIST: [
          {name:'사용안함', name2:"Not used",  value:0}
        , {name:'사용',   name2:"Used",   value:1}
      ],
 
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,
      
    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      changetype(){
        if(this.editedItem.LANTYPE == 4){
          this.editedItem.REQTYPE = 1;
        }
      },

      loadpage(){
        
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화

        this.loading = true;

          this.$http.post(this.$host+'/api/InputBasicList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.itemList.push(element); 
              });
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('inputbasic_msg1'));
          return;
        } 
        if(this.editedItem.INPUTDESC  == undefined || this.editedItem.INPUTDESC.length < 1){
          this.$alert(this.$t('inputbasic_msg2'));
          return;
        } 
        if(this.editedItem.ENAME  == undefined || this.editedItem.ENAME.length < 1){
          this.$alert(this.$t('inputbasic_msg7'));
          return;
        } 
        if(this.editedItem.EINPUTDESC  == undefined || this.editedItem.EINPUTDESC.length < 1){
          this.$alert(this.$t('inputbasic_msg8'));
          return;
        } 


        if(this.editedItem.LANTYPE == 4){
          if(this.editedItem.WIDTH  == null || this.editedItem.WIDTH  == undefined){
            this.$alert(this.$t('inputbasic_msg3'));
            return;
          } 
          if(this.editedItem.HEIGHT  == null || this.editedItem.HEIGHT  == undefined){
            this.$alert(this.$t('inputbasic_msg4'));
            return;
          } 
          if(this.editedItem.WIDTH > 1200){
            this.$alert(this.$t('inputbasic_msg5'));
            return;
          } 
          if(this.editedItem.HEIGHT > 1200){
            this.$alert(this.$t('inputbasic_msg6'));
            return;
          } 
        }

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/InputBasicUpdate',{
                NAME: escape(this.editedItem.NAME)
              , INPUTDESC: escape(this.editedItem.INPUTDESC)
              , ENAME: escape(this.editedItem.ENAME)
              , EINPUTDESC: escape(this.editedItem.EINPUTDESC)
              , INPUTCOMMENT: this.editedItem.INPUTCOMMENT == null || this.editedItem.INPUTCOMMENT == undefined ? '' : escape(this.editedItem.INPUTCOMMENT)
              , EINPUTCOMMENT: this.editedItem.EINPUTCOMMENT == null || this.editedItem.EINPUTCOMMENT == undefined ? '' : escape(this.editedItem.EINPUTCOMMENT)
              , LANTYPE: this.editedItem.LANTYPE
              , REQTYPE: this.editedItem.REQTYPE
              , USETYPE: this.editedItem.USETYPE
              , SHOWTYPE: this.editedItem.SHOWTYPE
              , LIMITTEXT: this.editedItem.LIMITTEXT
              , WIDTH: this.editedItem.WIDTH == null || this.editedItem.WIDTH == undefined ? 0 : this.editedItem.WIDTH
              , HEIGHT:  this.editedItem.HEIGHT == null || this.editedItem.HEIGHT == undefined ? 0 : this.editedItem.HEIGHT
              , MAXLINES: this.editedItem.MAXLINES
              , INPUT_CODE: this.editedItem.INPUT_CODE
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }

        this.close()

      },      


      //검색
      search_run(){
        this.loadpage();
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

      //국가선택 콜백
      nationcallback(var1){
        if(var1.NAMEKOR.length > 0){
          this.editedItem.NATION  = var1.NACODE;
          this.editedItem.NAMEKOR = var1.NAMEKOR;
        }
      }


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>